/* Breadcrumb auto-dropdowns. UMD: window.RohitBC + window.initBreadcrumbDropdowns
   in the browser; module.exports in node (for docs/tasks/check-breadcrumb-dropdowns.mjs).
   Pure builders return HTML strings; init() enhances the already-built breadcrumb DOM. */
(function (root, factory) {
    var api = factory();
    if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
    if (root) { root.RohitBC = api; root.initBreadcrumbDropdowns = api.init; }
})(typeof self !== 'undefined' ? self : (typeof global !== 'undefined' ? global : this), function () {

    var CHANNEL_ORDER = ['notes', 'thoughts', 'frames-episodes-play'];
    // Channels with no palette entry of their own borrow another slug's colour:
    var CHANNEL_COLOUR = { 'notes': 'notes', 'thoughts': 'blog', 'frames-episodes-play': 'frames-episodes-play' };
    // Slugs that own a palette colour (a [data-col] accent exists). Others inherit their channel.
    var COLOURED = ['blog', 'art-and-expression', 'mental-models-and-frameworks', 'movies', 'tv-shows', 'games', 'music', 'documentaries', 'travel', 'books', 'tools', 'frames-episodes-play', 'notes'];
    // Per-slug URL overrides: the Books collection landing is the curated reading-list page.
    var URL_OVERRIDE = { 'books': '/my-reading-list/' };
    function hrefFor(slug) { return URL_OVERRIDE[slug] || ('/' + slug + '/'); }

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function isColoured(slug) { for (var i = 0; i < COLOURED.length; i++) { if (COLOURED[i] === slug) return true; } return false; }
    function label(map, slug) { return (map && map[slug]) || (slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, ' ')); }
    function colourSlugFor(slug, channelSlug) { return isColoured(slug) ? slug : CHANNEL_COLOUR[channelSlug]; }

    function row(opts) { // {href, col, text, cls, current, indent, tocId, dot}
        var cls = 'bc-row' + (opts.indent ? ' bc-row--lvl3' : '') + (opts.current ? ' is-current' : '') + (opts.cls ? ' ' + opts.cls : '');
        var dataCol = opts.col ? ' data-col="' + escapeHtml(opts.col) + '"' : '';
        var tocId = opts.tocId != null ? ' data-toc-id="' + escapeHtml(opts.tocId) + '"' : '';
        var here = opts.current ? '<span class="bc-here">you are here</span>' : '';
        var dot = opts.dot === false ? '' : '<span class="bc-dot"></span>';
        var aria = opts.current ? ' aria-current="true"' : '';
        return '<li class="bc-li"><a class="' + cls + '"' + dataCol + tocId + ' href="' + escapeHtml(opts.href) + '"' + aria + '>' +
               dot + '<span class="bc-row-text">' + escapeHtml(opts.text) + '</span>' + here + '</a></li>';
    }

    // Owner-editable visibility list (partials/config/control-breadcrumbs-visibility.hbs).
    // Returns null when no usable list is supplied => NOTHING is filtered and the output is
    // byte-identical to the pre-visibility behaviour (fail-open: never hides by accident).
    // An explicitly EMPTY array is honoured as "show nothing" and collapses the whole dropdown.
    function visibilityIndex(list) {
        if (!list || Object.prototype.toString.call(list) !== '[object Array]') return null;
        var idx = {};
        for (var i = 0; i < list.length; i++) { idx[String(list[i])] = true; }
        return idx;
    }

    // `visible` is optional. Omit it (as the node harness does) and every row is drawn.
    function buildSiteMapHTML(config, currentSlug, visible) {
        var sections = config.channelSections || {};
        var order = config.pinOrder || {};
        var map = config.slugMapping || {};
        var vis = visibilityIndex(visible);
        function shown(slug) { return !vis || vis[slug] === true; }
        var body = '';
        var inChannel = {};
        for (var ci = 0; ci < CHANNEL_ORDER.length; ci++) {
            var ch = CHANNEL_ORDER[ci];
            if (!sections[ch]) continue;
            var cols = order[ch] || sections[ch];
            // Claim every child for its channel BEFORE testing visibility. Doing this after the
            // filter would let a hidden child fall through to the standalone list at the bottom
            // and REAPPEAR there, which is the opposite of what hiding it means.
            for (var k = 0; k < cols.length; k++) { inChannel[cols[k]] = true; }
            var visibleCols = [];
            for (var v = 0; v < cols.length; v++) { if (shown(cols[v])) { visibleCols.push(cols[v]); } }
            // A heading is drawn when something under it survives, or when the heading itself is
            // listed by name (the "heading with nothing underneath" case).
            if (!visibleCols.length && !shown(ch)) continue;
            var chCol = CHANNEL_COLOUR[ch];
            var chCurrent = (ch === currentSlug);
            body += '<li class="bc-li"><a class="bc-ch-head' + (chCurrent ? ' is-current' : '') + '" data-col="' + escapeHtml(chCol) +
                    '" href="' + escapeHtml(hrefFor(ch)) + '"' + (chCurrent ? ' aria-current="true"' : '') +
                    '><span class="bc-sw"></span><span class="bc-row-text">' + escapeHtml(label(map, ch)) + '</span></a></li>';
            for (var i = 0; i < visibleCols.length; i++) {
                var slug = visibleCols[i];
                body += row({ href: hrefFor(slug), col: colourSlugFor(slug, ch), text: label(map, slug), current: slug === currentSlug, indent: true });
            }
        }
        // standalone collections = collectionOnlyPages not inside any channel
        var standalone = (config.collectionOnlyPages || []).filter(function (s) { return !inChannel[s] && shown(s); });
        if (standalone.length) {
            // Only rule the divider when there is something above it to divide from.
            if (body) { body += '<li class="bc-divider"></li>'; }
            for (var j = 0; j < standalone.length; j++) {
                var s2 = standalone[j];
                body += row({ href: hrefFor(s2), col: colourSlugFor(s2, null), text: label(map, s2), current: s2 === currentSlug, cls: 'bc-row--top' });
            }
        }
        // Nothing survived: return an empty string so init() skips the dropdown entirely rather
        // than opening a box containing only its own heading.
        if (!body) return '';
        return '<ul class="bc-pop bc-sitemap" role="menu"><li class="bc-menu-head">Site sections</li>' + body + '</ul>';
    }

    function buildTocHTML(headings) {
        // Indent each heading by its depth relative to the SHALLOWEST heading present, so an
        // H2/H3 post still starts flush left while an H1..H6 post nests fully (depths 0..5).
        var min = 6, m;
        for (m = 0; m < headings.length; m++) { if (headings[m].level < min) { min = headings[m].level; } }
        var html = '<ul class="bc-pop bc-toc" role="menu"><li class="bc-menu-head">On this page</li>';
        for (var i = 0; i < headings.length; i++) {
            var h = headings[i];
            var depth = h.level - min;
            html += '<li class="bc-li"><a class="bc-row bc-row--d' + depth + '" data-toc-id="' +
                    escapeHtml(h.id) + '" href="#' + escapeHtml(h.id) + '"><span class="bc-tick"></span>' +
                    '<span class="bc-row-text">' + escapeHtml(h.text) + '</span></a></li>';
        }
        return html + '</ul>';
    }

    function buildSiblingsHTML(items, currentUrl, collectionName, colSlug) {
        var seen = {}, list = [];
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (!it || !it.url || seen[it.url]) continue;
            seen[it.url] = true; list.push(it);
        }
        list.sort(function (a, b) {
            var x = a.title.toLowerCase(), y = b.title.toLowerCase();
            return x < y ? -1 : (x > y ? 1 : 0);
        });
        var html = '<ul class="bc-pop bc-siblings" role="menu" data-col="' + escapeHtml(colSlug) +
                   '"><li class="bc-menu-head">More in ' + escapeHtml(collectionName) + '</li>';
        for (var k = 0; k < list.length; k++) {
            html += row({ href: list[k].url, col: colSlug, text: list[k].title, current: list[k].url === currentUrl });
        }
        return html + '</ul>';
    }

    // ---------- DOM enhancer ----------
    function wrap(el, popHTML, kind) {
        if (!el || !el.parentNode) return null;
        var w = document.createElement('span');
        w.className = 'bc-haspop';
        w.setAttribute('data-pop', kind);
        el.parentNode.insertBefore(w, el);
        w.appendChild(el);
        w.insertAdjacentHTML('beforeend', popHTML);
        el.setAttribute('aria-haspopup', 'true');
        el.setAttribute('aria-expanded', 'false');
        function open() { el.setAttribute('aria-expanded', 'true'); }
        function close() { el.setAttribute('aria-expanded', 'false'); }
        w.addEventListener('mouseenter', open); w.addEventListener('mouseleave', close);
        w.addEventListener('focusin', open); w.addEventListener('focusout', close);
        return w;
    }

    function init() {
        if (typeof document === 'undefined') return;
        var cfg = window.RohitThemeConfig || {};
        var path = window.location.pathname.split('/').filter(Boolean);
        var currentSlug = path[0] || '';
        var currentUrl = window.location.pathname;
        var container = document.querySelector('.breadcrumbs-container');
        if (!container) return;

        var hasParent = !!container.querySelector('.breadcrumb-parent');

        // 1) SITE MAP on the collection/channel item (parent on posts, title on archive pages).
        // The visible-section list is owner-edited in partials/config/control-breadcrumbs-visibility.hbs.
        var collEl = container.querySelector('.breadcrumb-parent') || container.querySelector('.breadcrumb-title');
        if (collEl) {
            var siteMapHTML = buildSiteMapHTML(cfg, currentSlug, window.RohitBreadcrumbsVisible);
            if (siteMapHTML) { wrap(collEl, siteMapHTML, 'sitemap'); }
        }

        // 2) SIBLING POSTS on the post title (only when a parent exists AND a pool is present)
        if (hasParent) {
            var titleEl = container.querySelector('.breadcrumb-title');
            var poolEl = document.querySelector('[data-bc-siblings]');
            if (titleEl && poolEl) {
                var items = [];
                var lis = poolEl.querySelectorAll('li[data-u]');
                for (var p = 0; p < lis.length; p++) {
                    items.push({ title: lis[p].textContent.trim(), url: lis[p].getAttribute('data-u') });
                }
                if (items.length) {
                    var collName = (cfg.slugMapping && cfg.slugMapping[currentSlug]) ||
                        (currentSlug.charAt(0).toUpperCase() + currentSlug.slice(1).replace(/-/g, ' '));
                    wrap(titleEl, buildSiblingsHTML(items, currentUrl, collName, currentSlug), 'siblings');
                }
            }
        }

        // 3) TABLE OF CONTENTS on the section item (when the article has headings)
        var headingSel = '.single-content h1, .single-content h2, .single-content h3, .single-content h4, .single-content h5, .single-content h6, .gh-content h1, .gh-content h2, .gh-content h3, .gh-content h4, .gh-content h5, .gh-content h6';
        var headingNodes = document.querySelectorAll(headingSel);
        var sectionEl = container.querySelector('.breadcrumb-section');
        if (sectionEl && headingNodes.length) {
            var headings = [];
            for (var i = 0; i < headingNodes.length; i++) {
                var n = headingNodes[i];
                if (!n.id) { n.id = 'bc-h-' + i; }
                headings.push({ level: parseInt(n.tagName.charAt(1), 10) || 2, text: n.textContent.trim(), id: n.id });
            }
            var w = wrap(sectionEl, buildTocHTML(headings), 'toc');
            // keep the TOC's current row in sync with the existing scroll-spy (matches by heading text)
            if (w) {
                window.addEventListener('scroll', function () {
                    var active = sectionEl.querySelector('.breadcrumb-text');
                    var activeText = active ? active.textContent.trim() : '';
                    var rows = w.querySelectorAll('.bc-row');
                    for (var r = 0; r < rows.length; r++) {
                        var on = rows[r].querySelector('.bc-row-text');
                        var match = on && on.textContent.trim() === activeText;
                        rows[r].classList.toggle('is-current', !!match);
                        if (match) { rows[r].setAttribute('aria-current', 'true'); } else { rows[r].removeAttribute('aria-current'); }
                    }
                }, { passive: true });
            }
        }
    }

    return { buildSiteMapHTML: buildSiteMapHTML, buildTocHTML: buildTocHTML, buildSiblingsHTML: buildSiblingsHTML, escapeHtml: escapeHtml, init: init };
});
